export const dashedToTitle = (dashed: string): string => {
  return dashed
    .split("-")
    .map((s) => (s.length > 0 ? `${s[0]!.toUpperCase()}${s.slice(1)}` : ""))
    .join(" ")
}

export const originFromPathOrURL = (
  path: string,
  prefixed: boolean = false
): string | undefined => {
  try {
    return new URL(path).host
  } catch (e) {
    if (!prefixed) {
      return originFromPathOrURL(window.location.host + path, true)
    }
  }
  return undefined
}
